import React from "react";
import { cssModifiers } from "../utils/sass";
import Icon from "./layout/icon";

function SelectDate({ dateOptions, date, onSelectDate }) {
  return (
    <section className="pick-date">
      <p className="pick-date__title rifa-title">Data de Sorteio</p>
      <div className="pick-date__cards">
        {dateOptions.map((dateOption, index) => {
          const dateText = dateOption.split(" ")[0].split("-").reverse().join("/");
          const weekDay = [
            "Domingo",
            "Segunda-feira",
            "Terça-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "Sábado",
          ][new Date(`${dateOption}`).getDay()];
          const selected = date == index;
          const modifiers = { selected };
          const css = cssModifiers(modifiers);

          return (
            <React.Fragment>
              <div
                className={css("pick-date__card", "selected")}
                onClick={() => onSelectDate(index)}
              >
                <div className={css("pick-date__card__icon", "selected")}>
                  <Icon type="calendar" color={selected ? "white" : "main"} />
                </div>
                <div className={css("pick-date__card__text", "selected")}>
                  <span className={css("pick-date__card__weekday", "selected")}>
                    {weekDay}
                  </span>
                  <br />
                  <span className={css("pick-date__card__date", "selected")}>
                    {dateText}
                  </span>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </section>
  );
}

export default SelectDate;



// WEBPACK FOOTER //
// ./src/rifa/components/selectDate.jsx